export const adminConstants = {
  HANDLE_TITLE_CHANGE: 'HANDLE_TITLE_CHANGE',
};
